export default "__VITE_ASSET__hrnZ22su__"